/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Medical Parameters Creation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './medicalParametersViewEdit';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsMedParamViewEdit = mapStateToProps;
export const mapDispatchToPropsMedParamViewEdit = mapDispatchToProps;

export default connect(
  mapStateToPropsMedParamViewEdit,
  mapDispatchToPropsMedParamViewEdit
)(View);
